import { Component, Input } from '@angular/core';
import { CancellationQuote } from 'src/app/core/models/cancellation.model';

@Component({
  selector: 'app-cancellation-quote-resume',
  templateUrl: './cancellation-quote-resume.component.html',
})
export class CancellationQuoteResumeComponent  {
  @Input() cancellationQuote: CancellationQuote;
  


}
